import { api } from 'api';
import type { FollowUpDetails, MonitoringType } from 'api';
import { rtkQueryApi } from '../rtkQueryApi';

export const followUpApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    canAddFollowUpForMonitoring: builder.query<
      boolean,
      { monitoringId: number; monitoringType: MonitoringType }
    >({
      query: ({ monitoringId, monitoringType }) => {
        return api.followUp.canAddFollowUpForMonitoring({ monitoringId, monitoringType });
      },
      providesTags: ['SpeakingMonitoring', 'LifeSkillsMonitoring', 'EorSpeakingMonitoring'],
    }),
    getFollowUp: builder.query<FollowUpDetails, { id: number }>({
      query: ({ id }) => {
        return api.followUp.get({ followUpId: id });
      },
      providesTags: ['SpeakingMonitoring', 'LifeSkillsMonitoring', 'EorSpeakingMonitoring'],
    }),
    createFollowUp: builder.mutation<FollowUpDetails, FollowUpDetails>({
      query: (followUpDetails) => {
        return api.followUp.save(followUpDetails);
      },
      invalidatesTags: [
        'SpeakingMonitoring',
        'LifeSkillsMonitoring',
        'EorSpeakingMonitoring',
        'ExaminerStatus',
        'Examiner',
      ],
    }),
    updateFollowUp: builder.mutation<FollowUpDetails, FollowUpDetails>({
      query: (followUpDetails) => {
        return api.followUp.save(followUpDetails);
      },
      invalidatesTags: [
        'SpeakingMonitoring',
        'LifeSkillsMonitoring',
        'EorSpeakingMonitoring',
        'ExaminerStatus',
        'Examiner',
      ],
    }),
    deleteFollowUp: builder.mutation<void, FollowUpDetails>({
      query: (followUpDetails) => {
        return api.followUp.deleteFollowUp(followUpDetails);
      },
      invalidatesTags: [
        'SpeakingMonitoring',
        'LifeSkillsMonitoring',
        'EorSpeakingMonitoring',
        'ExaminerStatus',
        'Examiner',
      ],
    }),
  }),
});

export const {
  useCanAddFollowUpForMonitoringQuery,
  useGetFollowUpQuery,
  useCreateFollowUpMutation,
  useUpdateFollowUpMutation,
  useDeleteFollowUpMutation,
} = followUpApi;
